import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { addDisplayName } from "../Infra/display-name";
import { ProgressLoadingScreen } from "./ProgressLoadingScreen";
import { ButtonContainer, MainContainer, ParentContainer } from "./DocumentRetrievalRecordsShared.styles";
import { TextButton } from "./PatientConsentManagerShared.styles";
export const DocumentRetrievalHURLoading = observer((props) => {
    const { t } = useTranslation(["patients"]);
    const { model } = props;
    const [time, setTime] = React.useState(0);
    const timeAtMax = model.hurLoadingTimeAtMax;
    const max = 0.95;
    const halfLife = timeAtMax * 0.231;
    const animationTick = 0.1;
    React.useEffect(() => {
        const progressInterval = setInterval(() => {
            setTime((prev) => {
                return prev + animationTick;
            });
        }, 1000 * animationTick);
        return () => {
            clearInterval(progressInterval);
        };
    }, []);
    const effectiveTime = time > halfLife * 2 ? Math.floor(time) : time;
    const progress = Math.min(1 - 2 ** (-effectiveTime / halfLife), max);
    const [areButtonsAnimating, setAreButtonsAnimating] = React.useState(false);
    const [buttonsVisible, setButtonsVisible] = React.useState(false);
    const animationDelay = 3 * 1000;
    React.useEffect(() => {
        let timer = setTimeout(() => {
            setAreButtonsAnimating(true);
            setButtonsVisible(true);
            timer = setTimeout(() => {
                setAreButtonsAnimating(false);
            }, 400);
        }, animationDelay);
        return () => clearTimeout(timer);
    }, []);
    return (_jsxs(ParentContainer, { children: [_jsx(MainContainer, { animate: false, isAnimating: false, children: _jsx(ProgressLoadingScreen, { title: model.hurLoadingTitle, subtitle: model.hurLoadingSubtitle, progress: progress }) }), buttonsVisible && (_jsx(ButtonContainer, { isAnimating: areButtonsAnimating, animate: true, children: _jsx(TextButton, { onClick: () => model.hurLoadingGoToHealthEx(), children: model.hurLoadingExitButtonText }) }))] }));
});
addDisplayName(DocumentRetrievalHURLoading, "DocumentRetrievalHURLoading");
